import * as R from 'ramda'
import {
  RESET_EMPLOYEE_LIST,
  UPDATE_EMPLOYEE_LIST,
} from './constants'

import { createReducer } from 'helpers/ReducerUtil'

const updateEmployeeList = (prevEmployees, { employees }) => {
  return employees ? R.merge(prevEmployees, employees) : prevEmployees
}

const employeeListReducer = createReducer({}, {
  [RESET_EMPLOYEE_LIST]: () => ( {} ),
  [UPDATE_EMPLOYEE_LIST]: updateEmployeeList
})

export default employeeListReducer
